// extracted by mini-css-extract-plugin
export default {"image-gallery":"images-gallery_image-gallery__fM2RG"};